import { render } from "./AccountingBody.vue?vue&type=template&id=246060ec&scoped=true"
import script from "./AccountingBody.vue?vue&type=script&lang=js"
export * from "./AccountingBody.vue?vue&type=script&lang=js"

import "./../../../assets/styles/admin/accounting/accounting.scss?vue&type=style&index=0&id=246060ec&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-246060ec"]])

export default __exports__